import { useContext } from 'react';
import Button from '../../../../components/Button';
import Detail from '../../../../components/Detail';
import modalContext from '../../../../context/modal/modalContext';
import { formatUSD } from '../../../../helpers/formats';
import useClaimableStakingRewards from '../../../../hooks/web3/vault/useClaimableStakingRewards';

const RewardActions = () => {
    const { openModal } = useContext(modalContext);

    const { claimableStakingRewards } = useClaimableStakingRewards();

    const claim = () => openModal('claimAllStakingRewardsModal');
    const stake = () => openModal('stakeEmissionRewardsModal');

    const totalStakingRewards = claimableStakingRewards
        ? Object.values(claimableStakingRewards).reduce((total, stakingRewards) => {
              const totalRewards = Object.values(stakingRewards).reduce(
                  (totalReward, reward) => (totalReward += reward),
                  0
              );

              return (total += totalRewards);
          }, 0)
        : 0;

    return (
        <div className='reward-actions'>
            <Detail
                title='Your Claimable Rewards'
                value={
                    <>
                        {claimableStakingRewards &&
                        Object.keys(claimableStakingRewards).length
                            ? formatUSD(
                                  (claimableStakingRewards.spoolRewards['SPOOL'] ?? 0) +
                                      (claimableStakingRewards.voSpoolRewards['SPOOL'] ??
                                          0) || 0
                              )
                            : '0.00'}{' '}
                        $SPOOL
                    </>
                }
            />
            <Button onClick={claim} disabled={!totalStakingRewards}>
                Claim Rewards
            </Button>
            <Button onClick={stake} disabled={!totalStakingRewards}>
                Stake Rewards
            </Button>
        </div>
    );
};

export default RewardActions;
